import { FetchRequest } from "@rails/request.js";
import { DistanceServices } from "./distance_services";
import { DeviceResolver } from "./device_resolver";
import { createCustomMapBubble } from "./custom_bubble";

let activeCustomMarker = undefined;

const removeClassesFromInactive = function (elem) {
  elem.className = elem.className.replace(/[a-z]{1,}-pin-active/, "");
  elem.classList.remove("active-pin");
  elem.classList.remove("previously-clicked");
  return elem;
};

const createCustomMapMarker = function ({location, map, isMobile, OverlayView = google.maps.OverlayView}) {
  class CustomMapMarker extends OverlayView {
    constructor(location, map, isMobile) {
      super();
      this.latlng = new google.maps.LatLng(
        location.latitude,
        location.longitude,
      );
      this.location = location;
      this.map = map;
      this.isMobile = isMobile;
      this.setMap(map);
    }

    MAP_STYLES = {
      eLocker: "locker-pin",
      "Group Parking": "group-pin",
      "Bike Hangar": "hangar-pin",
      eRack: "erack-pin",
      Vendor: "vendor-pin",
    };

    PROBLEM_STYLES = {
      "Work Order": "work-order-pin",
      "Problem report": "problem-report-pin",
      "Both problems": "both-problem-pin",
    };

    createDiv() {
      this.div = document.createElement("div");

      if (this.location.type === "friendly_type") {
        this.div.className =
          "map-marker " + this.MAP_STYLES[this.location.location_friendly_type];
      } else {
        const count_problems =
          this.location.problem_reports.length +
          this.location.work_orders.length;
        if (count_problems > 9) {
          this.div.innerHTML = "9+";
        } else {
          this.div.innerHTML = count_problems;
        }
        if (
          this.location.problem_reports.length > 0 &&
          this.location.work_orders.length > 0
        ) {
          this.div.className =
            "map-marker count-pin " + this.PROBLEM_STYLES["Both problems"];
        } else {
          if (this.location.problem_reports.length > 0) {
            this.div.className =
              "map-marker count-pin " + this.PROBLEM_STYLES["Problem report"];
          } else {
            this.div.className =
              "map-marker count-pin " + this.PROBLEM_STYLES["Work Order"];
          }
        }
      }

      if (!this.isMobile) {
        return this.addDesktopListener();
      }
      if (DeviceResolver.isTablet()) {
        return this.addTabletListener();
      }
      return this.addMobileListener();
    }

    addDesktopListener() {
      const self = this;
      this.div.addEventListener("mouseleave", function (event) {
        if (activeCustomMarker) {
          activeCustomMarker.deactivate();
        }
        return self.deactivate();
      });
      this.div.addEventListener("mouseenter", function (event) {
        if (activeCustomMarker) {
          activeCustomMarker.deactivate();
        }
        return self.activate();
      });
      this.div.addEventListener("click", function (event) {
        self.showLocationDetail();
        return self.clickActivate();
      });
    }

    addTabletListener() {
      const self = this;
      this.div.addEventListener("click", function (event) {
        if (activeCustomMarker) {
          activeCustomMarker.deactivate();
        }
        self.showLocationDetail();
        return self.activate();
      });
    }

    addMobileListener() {
      const self = this;
      this.div.addEventListener("click", function (event) {
        if (activeCustomMarker) {
          activeCustomMarker.deactivate();
        }
        map.setCenter(self.getPosition());
        return self.activate();
      });
    }

    appendDivToOverlay() {
      return this.getPanes().overlayImage.appendChild(this.div);
    }

    positionDiv() {
      const point = this.getProjection().fromLatLngToDivPixel(this.latlng);
      if (point) {
        this.div.style.left = point.x + "px";
        return (this.div.style.top = point.y + "px");
      }
    }

    draw() {
      if (!this.div) {
        this.createDiv();
        this.appendDivToOverlay();
      }
      return this.positionDiv();
    }

    getPosition() {
      return this.latlng;
    }

    addMapPinStyle() {
      if (this.location.type === "friendly_type") {
        return this.div.classList.add(
          this.MAP_STYLES[this.location.location_friendly_type] + "-active",
        );
      } else {
        this.div.classList.add("new-active-pin");
        if (
          this.location.problem_reports.length > 0 &&
          this.location.work_orders.length > 0
        ) {
          return this.div.classList.add(
            this.PROBLEM_STYLES["Both problems"] + "-active",
          );
        } else {
          if (this.location.problem_reports.length > 0) {
            return this.div.classList.add(
              this.PROBLEM_STYLES["Problem report"] + "-active",
            );
          } else {
            return this.div.classList.add(
              this.PROBLEM_STYLES["Work Order"] + "-active",
            );
          }
        }
      }
    }

    removeMapPinStyle() {
      if (this.div.classList.contains("click")) {
        return;
      }

      if (this.location.type === "friendly_type") {
        return this.div.classList.remove(
          this.MAP_STYLES[this.location.location_friendly_type] + "-active",
        );
      } else {
        this.div.classList.remove("new-active-pin");
        if (
          this.location.problem_reports.length > 0 &&
          this.location.work_orders.length > 0
        ) {
          return this.div.classList.remove(
            this.PROBLEM_STYLES["Both problems"] + "-active",
          );
        } else {
          if (this.location.problem_reports.length > 0) {
            return this.div.classList.remove(
              this.PROBLEM_STYLES["Problem report"] + "-active",
            );
          } else {
            return this.div.classList.remove(
              this.PROBLEM_STYLES["Work Order"] + "-active",
            );
          }
        }
      }
    }

    clickActivate() {
      if (!this.div) {
        return;
      }
      const self = this;

      this.div.classList.add("click");
      self.addMapPinStyle();

      document.querySelectorAll(".click").forEach((element) => {
        if (element !== this.div) {
          element.classList.remove("click");
          element.classList.add("previously-clicked");
        }
      });

      document.querySelectorAll(".previously-clicked").forEach((element) => {
        element.classList.remove("active");
      });

      const element = document.querySelector(".previously-clicked");
      if (element) {
        return removeClassesFromInactive(element);
      }
    }

    activate() {
      if (!this.div) {
        return;
      }

      const self = this;
      activeCustomMarker = this;
      this.div.classList.add("active-pin");
      self.addMapPinStyle();
      const active_div = this.div;
      const possibleRemove = () =>
        active_div.classList.remove("new-active-pin");

      setTimeout(possibleRemove, 500);
      const callback = function () {
        if (!DeviceResolver.isTablet()) {
          return (self.customBubble = createCustomMapBubble({
            marker: self,
            location: self.location,
            map: self.map,
          }));
        }
      };
      return setTimeout(callback, 100);
    }

    deactivateClick() {
      if (!this.div) {
        return;
      }

      const nextClickElement = this.div.nextElementSibling?.classList.contains(
        "click",
      )
        ? this.div.nextElementSibling
        : null;

      document.querySelectorAll(".click").forEach((element) => {
        if (element !== nextClickElement) {
          element.classList.remove("click");
        }
      });
    }

    deactivate() {
      if (!this.div) {
        return;
      }

      activeCustomMarker = undefined;
      if (!this.div.classList.contains("click")) {
        this.div.classList.remove("active-pin");
      }
      const self = this;
      self.removeMapPinStyle();
      const callback = function () {
        if (self.customBubble) {
          return self.customBubble.remove();
        }
      };
      return setTimeout(callback, 100);
    }

    show() {
      if (!this.div) {
        return;
      }

      this.div.style.display = "block";
      return this.positionDiv();
    }

    hide() {
      if (!this.div) {
        return;
      }

      if (activeCustomMarker === this) {
        this.deactivate();
      }
      return (this.div.style.display = "none");
    }

    async showLocationDetail() {
      const self = this;
      const request = new FetchRequest(
        "get",
        `/maps/locations/${this.location.url_id}/sidebar_info`,
        {
          responseKind: "script",
        },
      );

      document.querySelectorAll(".miles-away").forEach((el) => {
        el.style.display = "none";
      });

      const response = await request.perform();
      if (response.ok) {
        CustomMapMarker.showDistanceForPosition({
          latitude: self.location.latitude,
          longitude: self.location.longitude,
        });
      }
    }

    static showDistanceForPosition(locationPosition) {
      if (!navigator.geolocation) {
        return;
      }

      return navigator.geolocation.getCurrentPosition(function (userPosition) {
        const distance = DistanceServices.distanceInBetweenGPSCoordinates(
          locationPosition,
          userPosition.coords,
        );
        const milesAwayNumber = document.getElementById("miles-away-number");
        if (milesAwayNumber) {
          milesAwayNumber.textContent = Number(
            Math.round(distance + "e" + 1) + "e-" + 1,
          );
        }

        document.querySelectorAll(".miles-away").forEach((el) => {
          el.style.display = "";
        });
      });
    }
  }

  return new CustomMapMarker(location, map, isMobile);
};

class CustomMapMarkersCollection {
  constructor(locations, map) {
    this.hide = this.hide.bind(this);
    this.show = this.show.bind(this);
    this.activate = this.activate.bind(this);
    this.allMarkers = {};
    this.activeMarkers = {};
    this.isMobile = DeviceResolver.isMobileOrTablet();
    this.activateGlobalListeners();
    this.build(locations, map);
  }

  activateGlobalListeners() {
    if (!this.isMobile) {
      return;
    }

    document.addEventListener("click", function (event) {
      const target = event.target;
      if (target.closest(".map-bubble") || target.closest(".map-marker")) {
        return;
      }
      if (activeCustomMarker && !DeviceResolver.isTablet()) {
        return activeCustomMarker.deactivate();
      }
    });
  }

  build(locations, map) {
    locations.forEach((location) => {
      const customMarker = createCustomMapMarker({
        location,
        map,
        isMobile: this.isMobile,
      });
      this.allMarkers[location.id] = customMarker;
      this.activeMarkers[location.id] = customMarker;
    });
  }

  hide(location_id) {
    if (!this.activeMarkers[location_id]) {
      return;
    }
    return this.activeMarkers[location_id].hide();
  }

  show(location_id) {
    if (!this.activeMarkers[location_id]) {
      return;
    }
    return this.activeMarkers[location_id].show();
  }

  showLocationsInBox(lat0, lng0, lat1, lng1) {
    Object.entries(this.allMarkers).forEach(([locationId, marker]) => {
      if (
        DistanceServices.inBoundingBox(
          lat0,
          lng0,
          lat1,
          lng1,
          marker.latlng.lat(),
          marker.latlng.lng(),
        )
      ) {
        this.activeMarkers[locationId] = marker;
        marker.show();
      } else {
        delete this.activeMarkers[locationId];
        marker.hide();
      }
    });
  }

  activate(location_id) {
    if (activeCustomMarker) {
      activeCustomMarker.deactivate();
    }
    return this.allMarkers[location_id].activate();
  }
}

export { CustomMapMarkersCollection };
